import { typeImportaciones } from "common/components/NavBar/Components/NavBarRegistred/MenuImportacionesGenerico"

export interface ImportacionFacturaEProps {
  id: string
  nombreFichero: string
  message?: string
}

export interface ImportacionFacturaProps {
  id: string
  nombreFichero: string
  message?: string[]
  numeroProcesadas: number
  numeroTotal: number
  idLotes?: string[]
  type: typeImportaciones
}

export interface ImportacionFacturaExcProps {
  id: string
  nombreFichero: string
  mensaje?: string
  numeroProcesadas: number
  numeroTotal: number
}

export interface ImportacionFacturaEuProps {
  id: string
  loteId: string
  message?: string
  nombreFichero: string
  numero: number | null
  totalFicheros: number
}

export interface ImportacionSageProps {
  exception: string | null
  lineasProcesadas: number
  lineasTotales: number
  nombreFichero: string
  id: string
}
export interface GlobalsStateProps {
  importacionesGenericas: Array<ImportacionFacturaProps>
  totalImportacionesFacturaE: number
  totalImportacionesFacturaExcel: number
}
export const globals: GlobalsStateProps = {
  importacionesGenericas: [],
  totalImportacionesFacturaE: 0,
  totalImportacionesFacturaExcel: 0,
}
